import React, { Component } from "react";
import { observer } from "mobx-react";
import { observable, action } from "mobx";

import Button from "@material-ui/core/Button";

import { ValidationForm } from "shared/validator";
import { Input } from "shared/wrapper";

@observer
class LoginPanel extends Component {
  //===========================================================================
  @observable loginId = "";
  @observable loginPw = "";
  //===========================================================================

  render() {
    return (
      <div id="bodyContent">
        <img src="img/login_logo.png" alt="site logo" />

        <div className="login_box">
          <ValidationForm onSubmit={this.login}>
            <div className="box_1" />
            <div className="box_2">
              <Input
                required
                minLength={5}
                maxLength={20}
                name="loginId"
                label="로그인ID"
                value={this.loginId}
                onChangeInput={this.changeInput}
                autoFocus={true}
              />
              <br />
              <Input
                required
                minLength={5}
                maxLength={20}
                name="loginPw"
                label="비밀번호"
                type="password"
                value={this.loginPw}
                onChangeInput={this.changeInput}
              />
            </div>
            <div className="box_3">
              <Button
                type="submit"
                variant="outlined"
                color="primary"
                className="login_btn"
              >
                로그인하기
              </Button>
            </div>
          </ValidationForm>
        </div>

        <br />
        <div className="login_text">
          ※ 아이디/패스워드 분실시 선생님께 문의를....
        </div>
      </div>
    );
  }
  //===========================================================================

  @action
  changeInput = e => {
    const { name, value } = e.target;
    this[name] = value;
  };

  /**
   * 로그인 메소드
   */
  login = () => {
    const { authStore } = this.props.rootStore;
    authStore.login({ id: this.loginId, pw: this.loginPw });
  };
  //===========================================================================
}

export default LoginPanel;
